import React, { createContext, useMemo } from 'react';

type MerchantContextValue = Record<string, unknown>;

export const MerchantContext = createContext<MerchantContextValue>({});

type MerchantContextProviderProps = {
  value?: MerchantContextValue;
  children: React.ReactNode;
};

const MerchantContextProvider = ({ value = {}, children }: MerchantContextProviderProps) => {
  const contextValue = useMemo(() => value, [value]);
  return <MerchantContext.Provider value={contextValue}>{children}</MerchantContext.Provider>;
};

export default MerchantContextProvider;
